import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
const Experience = () => {
	return (
		<div>
			<p className="py-2 pr-2">
				<span className="titleLogo"><FontAwesomeIcon className="fa-2x pt-2" icon={faBriefcase} /></span>
				<span className="titleText pl-3">WORK EXPERIENCE</span>
			</p>
			<div className="row pt-4 pl-4">
				<div className="col-md-4 companySection">
					<h5 className="headings">SEE ID, Inc(Senior Developer  L-3)</h5>
					<h3 className="pl-4">December-2023 - Present</h3>
				</div>
				<div className="col-md-8">
					<h5 className="headings">Job Description</h5>
					<p>* Planned and converted monolithic architecture to the micro service architecture</p>
					<p>* Implemented Logger system to store the logs in AWS bucket</p>
					<p>* Implemented real time data update on map with help of SocketIo</p>
					<p>* Planned and implemented GraphQL to avoid API latency and Work efficiently with Micro-service architecture</p>
					<p>* Planned and implemented Bulk upload to store the large amount of data in DB</p>
					<p>* Utilized NestJS lifecycle and implemented alert notifications on server crash</p>
					<p>* Helped and Implemented on-demand feature of AWS</p>
					<p>* Helped and mentored both Frontend and Backend team</p>
					<p>* Utilized varios methods of data storing in the server</p>
					<p>* For safety of env variables used AWS params store and written script to load variables from AWS store before service start</p>
					<p>* Implemented Husky to maintain the code quality on git commit</p>
					<p>* Implemented Keycloak for authentication</p>
					<p>* Used BullMQ to communicate between micro services</p>
					<p>* Worked and helped team to acheive complex Queries and Demo</p>
					<p>* Did mongo queries optimization by removing lookups and adding inbuilt features such as filter, map, etc</p>
					<p>* Used NextJS, NestJS, MongoDB, PostgreSQL, Docker, Github CI/CD, Kubernetes, SocketIO, GraphQL, BullMQ, Redis, Server-side Caching, Winston Logger</p>
				</div>
			</div>
			<div className="row pt-4 pl-4">
				<div className="col-md-4 companySection">
					<h5 className="headings">Refactor Academy(Senior Developer L-2)</h5>
					<h3 className="pl-4">July-2022 - December-2023</h3>
				</div>
				<div className="col-md-8">
					<h5 className="headings">Job Description</h5>
					<p>* Involved in gathering the project requirement, completing the HLD and LLD along with discussing with the core team.</p>
					<p>* Planned and built the API schema as per Business requirements.</p>
					<p>* Developed and designed multiple microservices from scratch and added functionalities as needed,
						IE:
						<ul>
							<li>Code compilation micro service using Judge0</li>
							<li>Throttle micro service for storing the compiled answer in DB and sending to FE  </li>
						</ul>
					</p>
					<p>* Used RabbitMQ to communicate between micro services.</p>
					<p>* Implemented PayU Payment Gateway for Payment transactions.</p>
					<p>* Studied and Improved queries of GraphQL.</p>
					<p>* Was actively involved in designing and developing CI/CD by Github actions in Kubernetes with Docker</p>
					<p>* Did Query optimization such as removing extra joins of table, Added indexing.   </p>
					<p>* Mentored junior developers and interns, and evaluate their performance</p>
					<p>* Used NestJS, MongoDB, PostgreSQL, Docker, Github CI/CD, Kubernetes, SocketIO, GraphQL, RabbitMQ, Redis, Server-side Caching</p>
				</div>
			</div>
			<div className="row pt-4 pl-4">
				<div className="col-md-4 companySection">
					<h5 className="headings">Tacnik Pvt Ltd(Junior Developer)</h5>
					<h3 className="pl-4">May-2021 - July-2022</h3>
				</div>
				<div className="col-md-8">
					<h5 className="headings">Job Description</h5>
					<p>* Assisting the web development team with all aspects of website and application design.</p>
					<p>* Explored various new Web Technologies like React Js, Express Js, Node Js, MongoDB, and PostgresSQL.</p>
					<p>* Implemented Various new UI Components to make Application more user friendly.</p>
					<p>* Built <b>User reaction</b> NPM package in React and published.</p>
					<p>* Brainstorming new tech applications.</p>
					<p>* Used NodeJS, ReactJS, HTML, CSS, MongoDB, Socket.IO</p>
				</div>
			</div>
			<div className="row pt-4 pl-4">
				<div className="col-md-4 companySection">
					<h5 className="headings">Temple Tree Tech (MERN stack developer)</h5>
					<h3 className="pl-4">Feb-2019 - April-2021</h3>
				</div>
				<div className="col-md-8">
					<h5 className="headings">Job Description</h5>
					<p>* Used Various technologies, including Javascript to make code repair and Optimize the website</p>
					<p>* Built N number of Projects by understanding and fullfilling the Client requirement</p>
					<p>* Building User Friendly Websites, and publishing in the Heroku, github, and Netlify. with CI/CD</p>
					<p>* Writing clean and readable code with test cases</p>
				</div>
			</div>
		</div>
	)
}


export default Experience